export const SCRIPT_KINDS = {
  brand_film: 'Brand film',
  testimonial: 'Testimonial',
  explainer: 'Explainer',
  social_short: 'Social short',
  fb_ad_campaign: 'Facebook ad campaign',
  interview_brief: 'Interview brief',
} as const;
export type ScriptKind = keyof typeof SCRIPT_KINDS;
export const DEFAULT_SCRIPT_KIND: ScriptKind = 'explainer';
export const SCRIPT_KIND_DESCRIPTIONS: Record<ScriptKind, string> = {
  brand_film: 'Story-led film about who they are and why',
  testimonial: 'A customer on camera, interview-led',
  explainer: 'How it works: voiceover and visuals',
  social_short: 'Under 60 seconds, vertical first',
  fb_ad_campaign: 'Hook variants and ad copy as a set',
  interview_brief: 'Questions and talking points for the shoot',
};

export const CALLSHEET_DOC_TYPES = {
  callsheet: 'Call sheet',
  client_schedule: 'Client schedule',
} as const;
export type CallsheetDocType = keyof typeof CALLSHEET_DOC_TYPES;
export const DEFAULT_CALLSHEET_DOC_TYPE: CallsheetDocType = 'callsheet';
export const CALLSHEET_DOC_TYPE_DESCRIPTIONS: Record<CallsheetDocType, string> = {
  callsheet: 'Crew-facing: call times, locations, contacts, kit',
  client_schedule: "Client-facing: the day's running order, no crew details",
};

export function isScriptKind(value: unknown): value is ScriptKind {
  return typeof value === 'string' && Object.prototype.hasOwnProperty.call(SCRIPT_KINDS, value);
}

export function isCallsheetDocType(value: unknown): value is CallsheetDocType {
  return typeof value === 'string' && Object.prototype.hasOwnProperty.call(CALLSHEET_DOC_TYPES, value);
}

/** Legacy and externally linked rows may not have a known type. */
export function artifactTypeLabel(tool: string, value: string | null): string | null {
  if (tool === 'script' && isScriptKind(value)) return SCRIPT_KINDS[value];
  if (tool === 'callsheet' && isCallsheetDocType(value)) return CALLSHEET_DOC_TYPES[value];
  return null;
}
